// Generated by scripts/facebook-testimonials (permalink refresh)
// Generated at: 2026-09-02T08:00:05.595Z
// Review count: 66
// Source: https://www.facebook.com/accesimpotqc/reviews

export const FACEBOOK_REVIEWS_URL = "https://www.facebook.com/accesimpotqc/reviews"

export const testimonials = [
  {
    "id": "fb-001",
    "displayName": "Michel S.",
    "facebookUrl": "https://www.facebook.com/michel.stonge.56/posts/pfbid0FkcjkSZcCzRjH2vkg7VLYjSD6iYEN6t9M83Y7k8wVAnkrgWDRP5NpnqfYwX6Mntpl",
    "postedAt": null,
    "sortOrder": 1,
    "qualityScore": 9,
    "originalLanguage": "fr",
    "originalText": {
      "fr": "Facilité d'accès et de transmission des documents. \nRapidité d'exécution, tout en tenant compte de nos questions et commentaires.\nPossibilité d'échanges par téléphone.\nExpériences positives après 2 ans d'utilisation."
    },
    "translatedText": {
      "en": "Easy access and document submission.\nFast turnaround, while still taking our questions and comments into account.\nOption to talk by phone.\nPositive experiences after 2 years of use."
    }
  },
  {
    "id": "fb-002",
    "displayName": "Gilles R.",
    "facebookUrl": "https://www.facebook.com/gilles.raymond.968108/posts/pfbid02dzw7YyVmJS7RHSqysTxH5ph4cVxBTXf9ayGQwhD6jvwCzE3c8JhhTJ58y64evrPGl",
    "postedAt": null,
    "sortOrder": 2,
    "qualityScore": 7.5,
    "originalLanguage": "fr",
    "originalText": {
      "fr": "Merci pour le bon service rapide et efficace!!!"
    },
    "translatedText": {
      "en": "Thank you for the great, fast and efficient service!!!"
    }
  },
  {
    "id": "fb-003",
    "displayName": "François V.",
    "facebookUrl": "https://www.facebook.com/francois.vezina.988/posts/pfbid02aWZqnCLHCEYuGc56oEzbPAtSdpbXrmC6WXnMnDW6wMkLcNr2ZWUK9Gs4jwLNRJU4l",
    "postedAt": null,
    "sortOrder": 3,
    "qualityScore": 6.5,
    "originalLanguage": "fr",
    "originalText": {
      "fr": "Service ultra rapide et professionnel!"
    },
    "translatedText": {
      "en": "Ultra fast and professional service!"
    }
  },
  {
    "id": "fb-004",
    "displayName": "Kathleen G.",
    "facebookUrl": "https://www.facebook.com/kathleen.gaud/posts/pfbid0zA8wtiwz1ycW2XkgMunNptSUw1bT9hv9oNEHUcjpWjqwTomQQwPoxspdywxRFhmcl",
    "postedAt": null,
    "sortOrder": 4,
    "qualityScore": 9,
    "originalLanguage": "fr",
    "originalText": {
      "fr": "Très efficaces, simple et rapide! \nLe chat est très efficace aussi, une question a n’importe quelle heure et on reçoit la réponse dès l’ouverture du ‘’ bureau’’ \nÇa fait 3 ans que j’utilise accès impôt et pour moi c’est une évidence pour l’année prochaine!"
    },
    "translatedText": {
      "en": "Very efficient, simple and fast!\nChat is also very effective — ask a question any time and you get an answer as soon as the “office” opens.\nI've been using Accès Impôt for 3 years and for me it's a given for next year!"
    }
  },
  {
    "id": "fb-005",
    "displayName": "Lucie P.",
    "facebookUrl": "https://www.facebook.com/lucie.prevost.10/posts/pfbid0KZsoK3f15xCwmGnXLT4moCc7eh3VV6adLeseuHQK37NKv7nVMUfx72SAcmJqwdSDl",
    "postedAt": null,
    "sortOrder": 5,
    "qualityScore": 6,
    "originalLanguage": "fr",
    "originalText": {
      "fr": "Très bon services ou rapidité et exactitude sont présents!"
    },
    "translatedText": {
      "en": "Very good service where speed and accuracy are both there!"
    }
  },
  {
    "id": "fb-006",
    "displayName": "Marie-Josée A.",
    "facebookUrl": "https://www.facebook.com/mariejosee.audy.3/posts/pfbid0WttHhXnFzdZJ4xKqmQNd4k7brXHofMcrzZMeapAjbEQXDNVV9omw4RT5J2csQTQCl",
    "postedAt": null,
    "sortOrder": 6,
    "qualityScore": 6,
    "originalLanguage": "fr",
    "originalText": {
      "fr": "Excellent service, rapidité et professionnalisme."
    },
    "translatedText": {
      "en": "Excellent service, speed and professionalism."
    }
  },
  {
    "id": "fb-007",
    "displayName": "Guillaume C.",
    "facebookUrl": "https://www.facebook.com/guillaume.constantin.3/posts/pfbid0Xmmzejr8mw5Q2VcHYmwihxGhpjaP6G5ej57U72vetDCeonLNhoxryKkDr9mJhLQsl",
    "postedAt": null,
    "sortOrder": 7,
    "qualityScore": 7.5,
    "originalLanguage": "fr",
    "originalText": {
      "fr": "Service rapide (2jours) et simple à utiliser"
    },
    "translatedText": {
      "en": "Fast service (2 days) and simple to use"
    }
  },
  {
    "id": "fb-008",
    "displayName": "Sonia B.",
    "facebookUrl": "https://www.facebook.com/sonia.blanchard.9/posts/pfbid02eEFtFhaGZZiALxxEEdCoKLLZQH72tKSU4Z6BNHAnoXx5zzgzpBtjbuG1Z6bZHwKxl",
    "postedAt": null,
    "sortOrder": 8,
    "qualityScore": 9,
    "originalLanguage": "fr",
    "originalText": {
      "fr": "Encore à la dernière minute cette année mais Accès Impôt m’a livré mes impôts à temps \nMerci pour votre service rapide et professionnel \nÀ l année prochaine!"
    },
    "translatedText": {
      "en": "Last minute again this year but Accès Impôt delivered my taxes on time\nThank you for your fast and professional service\nSee you next year!"
    }
  },
  {
    "id": "fb-009",
    "displayName": "Dany S.",
    "facebookUrl": "https://www.facebook.com/dany.savard.9/posts/pfbid062125tDtNqJMcnuvNaG2uj51xm3W1dCBwGTsw7hXd7MQ6FQFQ6JMRvaRboyy6VAGl",
    "postedAt": null,
    "sortOrder": 9,
    "qualityScore": 7.5,
    "originalLanguage": "fr",
    "originalText": {
      "fr": "Je refere simple et rapide, pas de déplacement et retour d'appel rapide, merci a l'équipe"
    },
    "translatedText": {
      "en": "I recommend — simple and fast, no travel and quick callbacks, thanks to the team"
    }
  },
  {
    "id": "fb-010",
    "displayName": "Richard S.",
    "facebookUrl": "https://www.facebook.com/richard.simard.148/posts/pfbid0GHxg3qp2VTQgiHWqaZtNYuRg4gvaYKQxWDsVJ1emWCtqha49Dn8dRQvmaWWHw22xl",
    "postedAt": null,
    "sortOrder": 10,
    "qualityScore": 5,
    "originalLanguage": "fr",
    "originalText": {
      "fr": "Superbe service je recommande"
    },
    "translatedText": {
      "en": "Superb service, I recommend it"
    }
  },
  {
    "id": "fb-011",
    "displayName": "IraAlexandra L.",
    "facebookUrl": "https://www.facebook.com/IraAlexandraLay/posts/pfbid0gn8Qc6kBAeA1wPZUK8W26cQQHERFvTFufZmRLRhD6GeD86MJzKXP9j8LCeyRXBuml",
    "postedAt": null,
    "sortOrder": 11,
    "qualityScore": 7.5,
    "originalLanguage": "fr",
    "originalText": {
      "fr": "Je recommande Accès Impôt facile d'accès,réponse rapide J'aime l'application Je le recommande à tous,aussi bon prix"
    },
    "translatedText": {
      "en": "I recommend Accès Impôt — easy access, fast replies. I like the app. I recommend it to everyone, and good prices too"
    }
  },
  {
    "id": "fb-012",
    "displayName": "Valérie M.",
    "facebookUrl": "https://www.facebook.com/valerie.marchaland/posts/pfbid02feVXWJtZdBamxEckHLFQT3N21ou8SzXdDVLzRdysBX3Cs6mqxNwbEPmJgJ51gEvil",
    "postedAt": null,
    "sortOrder": 12,
    "qualityScore": 7.5,
    "originalLanguage": "fr",
    "originalText": {
      "fr": "Service rapide, efficace et répond vite aux questions."
    },
    "translatedText": {
      "en": "Fast, efficient service that answers questions quickly."
    }
  },
  {
    "id": "fb-014",
    "displayName": "Reine G.",
    "facebookUrl": "https://www.facebook.com/BeauteMalika/posts/pfbid02jszn3uXvbm2nJs6EWHgDsWqnd9grS9mYeuGLrvZXGsV6mLmBrMaxWMct61pvhPXTl",
    "postedAt": null,
    "sortOrder": 14,
    "qualityScore": 7.5,
    "originalLanguage": "fr",
    "originalText": {
      "fr": "Première fois qu’on utilise  accès impôt,mon mari et moi. Nous avons bien apprécié la rapidité du processus. Bravo pour cette initiative!!!"
    },
    "translatedText": {
      "en": "First time my husband and I used Accès Impôt. We really appreciated how fast the process was. Bravo for this initiative!!!"
    }
  },
  {
    "id": "fb-015",
    "displayName": "Val B.",
    "facebookUrl": "https://www.facebook.com/val.boulet/posts/pfbid02vdFyiXoionaSuwTw53VKhp8FA2J7VZfUvGrX8K6eqpxNTDjvb6j6yrvCvtuVgsgbl",
    "postedAt": null,
    "sortOrder": 15,
    "qualityScore": 6,
    "originalLanguage": "en",
    "originalText": {
      "en": "Amazing service. So efficient and user friendly, couldn’t recommend more. Merci beaucoup Accès Impôt!"
    },
    "translatedText": {
      "fr": "Service extraordinaire. Tellement efficace et facile à utiliser, je ne pourrais pas plus le recommander. Merci beaucoup Accès Impôt!"
    }
  },
  {
    "id": "fb-016",
    "displayName": "Madeleine R.",
    "facebookUrl": "https://www.facebook.com/madeleine.roy.779/posts/pfbid02KaCjzS2ASHzTYDDUhX2S7sG8YbvbMHufmoSLNUuoGvijEMmFvFENBp3VxZULm2frl",
    "postedAt": null,
    "sortOrder": 16,
    "qualityScore": 9,
    "originalLanguage": "fr",
    "originalText": {
      "fr": "C’est ma deuxième année avec eux et le service est impeccable, rapide, et très juste dans les retour ou paiement à faire au gouvernement. Pas de surprise. Continuez votre bon travail."
    },
    "translatedText": {
      "en": "It's my second year with them and the service is impeccable, fast, and very accurate for refunds or amounts owed to the government. No surprises. Keep up the good work."
    }
  },
  {
    "id": "fb-017",
    "displayName": "Mailany T.",
    "facebookUrl": "https://www.facebook.com/melanie.turgeon/posts/pfbid0FK4YB1xLyC5dCLpVMt4sDfx26yPcYqUyiB5wyoE68UPDmbDfTyjTcxQFkooRTKdhl",
    "postedAt": null,
    "sortOrder": 17,
    "qualityScore": 7.5,
    "originalLanguage": "fr",
    "originalText": {
      "fr": "J'étais vraiment à la dernière minute. J'ai envoyé mes documents le 28 avril et le tout était prêt et envoyé aujourd'hui. Je suis impressionnée de la rapidité. C'est clair que je ne ferai plus mes impôts moi-même dans le futur!"
    },
    "translatedText": {
      "en": "I was really last minute. I sent my documents on April 28 and everything was ready and filed today. I'm impressed by the speed. Clearly I won't do my taxes myself again!"
    }
  },
  {
    "id": "fb-018",
    "displayName": "Sophie G.",
    "facebookUrl": "https://www.facebook.com/sophie.vaillancourt.758/posts/pfbid02LTyAsjQSKpiVTgdmCrzyG5jzhmPJ6BYnVjPWB59UqPwo2yqHK8E4Do3MXfzBPqJRl",
    "postedAt": null,
    "sortOrder": 18,
    "qualityScore": 5,
    "originalLanguage": "fr",
    "originalText": {
      "fr": "Très efficace, facilitant !"
    },
    "translatedText": {
      "en": "Very efficient and makes things easy!"
    }
  },
  {
    "id": "fb-019",
    "displayName": "Jean L.",
    "facebookUrl": "https://www.facebook.com/accesimpotqc/reviews",
    "postedAt": null,
    "sortOrder": 19,
    "qualityScore": 4.5,
    "originalLanguage": "fr",
    "originalText": {
      "fr": "Super service rapide !"
    },
    "translatedText": {
      "en": "Great fast service!"
    }
  },
  {
    "id": "fb-020",
    "displayName": "Nadine C.",
    "facebookUrl": "https://www.facebook.com/nadine.cote.31/posts/pfbid04dd4Lijm6aoL8xLSrz9exyB3WmFZEdWhYc4568J9ZGMkF25RYzFbjTro6tjPKo19l",
    "postedAt": null,
    "sortOrder": 20,
    "qualityScore": 9,
    "originalLanguage": "fr",
    "originalText": {
      "fr": "Facile et très rapide. J’ai scanné tous mes documents et je les ai téléchargés: Temps total 20 minutes. Envoyé jeudi soir, retour téléphonique samedi matin! Reste à voir si les différentes agences du revenu seront d’accord"
    },
    "translatedText": {
      "en": "Easy and very fast. I scanned all my documents and uploaded them: total time 20 minutes. Sent Thursday night, phone callback Saturday morning! Remains to be seen if the tax agencies agree"
    }
  },
  {
    "id": "fb-022",
    "displayName": "Carol-Ann P.",
    "facebookUrl": "https://www.facebook.com/carolann.poulin1/posts/pfbid02afxc8rszsda8enrqZgqKrUC6bioqnvRKjcY3HNDGUYw2CgHp3pFzuKVKynnnELr9l",
    "postedAt": null,
    "sortOrder": 22,
    "qualityScore": 7.5,
    "originalLanguage": "fr",
    "originalText": {
      "fr": "Efficace et rapide! Je recommande fortement"
    },
    "translatedText": {
      "en": "Efficient and fast! I strongly recommend"
    }
  },
  {
    "id": "fb-023",
    "displayName": "MA R.",
    "facebookUrl": "https://www.facebook.com/mareimund/posts/pfbid026diEnw82XGBWRkxBPwaRMNo3cNFV4hQEQY4JKHECUJqfJDJDtFiXMLPgfs6uXLYGl",
    "postedAt": null,
    "sortOrder": 23,
    "qualityScore": 6.5,
    "originalLanguage": "fr",
    "originalText": {
      "fr": "service rapide et à bon prix."
    },
    "translatedText": {
      "en": "Fast service at a good price."
    }
  },
  {
    "id": "fb-024",
    "displayName": "Gabrielle T.",
    "facebookUrl": "https://www.facebook.com/gabrielle.turgeon.52/posts/pfbid025SoNF3tEimNgbkj6yj8jM9a3ZMiQ64bpRrHCCFPf1P7ckm8t1twGhc25TdDAKFgfl",
    "postedAt": null,
    "sortOrder": 24,
    "qualityScore": 6.5,
    "originalLanguage": "fr",
    "originalText": {
      "fr": "Service super rapide et professionnel."
    },
    "translatedText": {
      "en": "Super fast and professional service."
    }
  },
  {
    "id": "fb-025",
    "displayName": "Marjolaine N.",
    "facebookUrl": "https://www.facebook.com/marjolainen1/posts/pfbid0hgmWZ2AeUtrULTa9QXQfQ3X21KJU5Cd7SNJK6WAtoEx3B59fVghKhGvmbKyfXLm8l",
    "postedAt": null,
    "sortOrder": 25,
    "qualityScore": 9,
    "originalLanguage": "fr",
    "originalText": {
      "fr": "Service rapide,  Plateforme facile à utiliser.  J' ai pu utiliser les données de l' an passé pour compléter mon rapport de cette année.  Personnel courtois."
    },
    "translatedText": {
      "en": "Fast service, easy-to-use platform. I was able to use last year's data to complete this year's return. Courteous staff."
    }
  },
  {
    "id": "fb-026",
    "displayName": "Josseline L.",
    "facebookUrl": "https://www.facebook.com/josseline.lheureux/posts/pfbid02rb7Uz1evP1vUvCxKo2o6dQtQ9VXcPVo7zJbX2EZiizD8H6hBWpLkPN1d752kVFMLl",
    "postedAt": null,
    "sortOrder": 26,
    "qualityScore": 7.5,
    "originalLanguage": "fr",
    "originalText": {
      "fr": "l'efficacité, la rapidité et le prix très avantageux...et de plus, une entreprise québécoise !!!!"
    },
    "translatedText": {
      "en": "Efficiency, speed and a very advantageous price... and on top of that, a Quebec company!!!!"
    }
  },
  {
    "id": "fb-027",
    "displayName": "Chantal B.",
    "facebookUrl": "https://www.facebook.com/chantal.belleau/posts/pfbid034PCoSHg5r8gpxsTVLx2dqkxVx8qmxv5RDN9m23tVRtyocRv9S1S8D9XDrtJCYrG9l",
    "postedAt": null,
    "sortOrder": 27,
    "qualityScore": 7.5,
    "originalLanguage": "fr",
    "originalText": {
      "fr": "Même à distance j’ai pu faire faire mes impôts et à une fraction du prix des grosses firmes comptables"
    },
    "translatedText": {
      "en": "Even remotely I was able to get my taxes done, and at a fraction of the price of big accounting firms"
    }
  },
  {
    "id": "fb-028",
    "displayName": "Julie V.",
    "facebookUrl": "https://www.facebook.com/julie.vachon.581/posts/pfbid037k31o5m7u9DiWFPFAjkoGggS3Nj981j3ukCrAU16iy8LhkYRd6wQHBDGk5XBzYvKl",
    "postedAt": null,
    "sortOrder": 28,
    "qualityScore": 6,
    "originalLanguage": "fr",
    "originalText": {
      "fr": "Accès facile a un humain en cas de problèmes"
    },
    "translatedText": {
      "en": "Easy access to a human when there are issues"
    }
  },
  {
    "id": "fb-029",
    "displayName": "Johanne P.",
    "facebookUrl": "https://www.facebook.com/johanne.pelchat.75/posts/pfbid028CTwuMJjzjFRYSi1CrZ4LVncATtofGVMTQ2woaLbUjMjuC6nzDGXeup4TFtBCCVEl",
    "postedAt": null,
    "sortOrder": 29,
    "qualityScore": 7.5,
    "originalLanguage": "fr",
    "originalText": {
      "fr": "Super service, facile, rapide et précis. Pas trop dispendieux non plus. Je recommande et ré-utiliserai."
    },
    "translatedText": {
      "en": "Great service — easy, fast and accurate. Not too expensive either. I recommend and will use again."
    }
  },
  {
    "id": "fb-030",
    "displayName": "Nick P.",
    "facebookUrl": "https://www.facebook.com/mini.pilon/posts/pfbid0viikKtScewezSSgHRUPHiwXhMNj2Xy2wuGN8JckdFLqfig6ydseVfrTwNn4cYXksl",
    "postedAt": null,
    "sortOrder": 30,
    "qualityScore": 7.5,
    "originalLanguage": "fr",
    "originalText": {
      "fr": "Rapide,simple et efficace! Très bonne communication!"
    },
    "translatedText": {
      "en": "Fast, simple and efficient! Very good communication!"
    }
  },
  {
    "id": "fb-031",
    "displayName": "Louis L.",
    "facebookUrl": "https://www.facebook.com/louis.lebel.54/posts/pfbid02bhojuvUVcrdJLK1mz3wpKajBoC8DPdA6X5DPqrhaVj1F61YCtYpawu76xJhKg8qzl",
    "postedAt": null,
    "sortOrder": 31,
    "qualityScore": 9,
    "originalLanguage": "fr",
    "originalText": {
      "fr": "Excellent service! Cadre professionnel… Deuxième année cette année et toujours aussi satisfait… Je recommande sans hésiter…"
    },
    "translatedText": {
      "en": "Excellent service! Professional setup… Second year this year and still just as satisfied… I recommend without hesitation…"
    }
  },
  {
    "id": "fb-032",
    "displayName": "Patricia R.",
    "facebookUrl": "https://www.facebook.com/patricia.robichaud.9/posts/pfbid0GCidg7aqvmhtsJWDf9oZ5CSDqTZEy5JqGVg5UXXS1bDY1GyvWpM1oLgLmfNNYNscl",
    "postedAt": null,
    "sortOrder": 32,
    "qualityScore": 6.5,
    "originalLanguage": "fr",
    "originalText": {
      "fr": "Service rapide et hyper efficace!"
    },
    "translatedText": {
      "en": "Fast and hyper-efficient service!"
    }
  },
  {
    "id": "fb-033",
    "displayName": "Andre O.",
    "facebookUrl": "https://www.facebook.com/andre.ouimet3/posts/pfbid02nYxzFVW7xQ8f4aBcC1Kn8GYm4JasYK7aQdAFfuyjjw6LZ5x65mhqs7c7X2YCnBoal",
    "postedAt": null,
    "sortOrder": 33,
    "qualityScore": 6.5,
    "originalLanguage": "fr",
    "originalText": {
      "fr": "Rapide efficace et simple"
    },
    "translatedText": {
      "en": "Fast, efficient and simple"
    }
  },
  {
    "id": "fb-034",
    "displayName": "Amélie L.",
    "facebookUrl": "https://www.facebook.com/amelie.lachapelle.5/posts/pfbid0UypRPRDTqwbmc6LSCae64g4dML4tQZhYgszY11G1iL5qfjC2xcq2jsmrk5GHQ8H9l",
    "postedAt": null,
    "sortOrder": 34,
    "qualityScore": 6.5,
    "originalLanguage": "fr",
    "originalText": {
      "fr": "Bon service très rapide je reccommande"
    },
    "translatedText": {
      "en": "Good, very fast service — I recommend"
    }
  },
  {
    "id": "fb-035",
    "displayName": "Marie-Claude C.",
    "facebookUrl": "https://www.facebook.com/marieclaude.comtois.5/posts/pfbid07eaRbPpiLyj4fMtkpJoE1421uGG2ssDswutDmmk6tcKcPQ1ECy2yFnWFCJVPCEvol",
    "postedAt": null,
    "sortOrder": 35,
    "qualityScore": 7.5,
    "originalLanguage": "fr",
    "originalText": {
      "fr": "Service rapide et professionnel. Facile à utiliser"
    },
    "translatedText": {
      "en": "Fast and professional service. Easy to use"
    }
  },
  {
    "id": "fb-036",
    "displayName": "Linh K.",
    "facebookUrl": "https://www.facebook.com/linh.kiki.707378/posts/pfbid02KhC9vdxqh75eCvwypYbBsBFjdSzin1ZJnWSmnqYfk6z8AN94EWs1kzHJSFJdgExbl",
    "postedAt": null,
    "sortOrder": 36,
    "qualityScore": 6,
    "originalLanguage": "fr",
    "originalText": {
      "fr": "Merci! Un bon service efficace et confiant. je recommended fortement!!"
    },
    "translatedText": {
      "en": "Thank you! Good, efficient and trustworthy service. I strongly recommend!!"
    }
  },
  {
    "id": "fb-037",
    "displayName": "Diane K.",
    "facebookUrl": "https://www.facebook.com/diane.knight.1800/posts/pfbid02okkXrzn7Bh38V3eYjaBJi8RvVthaTbQGQYozymfH2ftYwsD48Z6EWhDpqyVqb8jml",
    "postedAt": null,
    "sortOrder": 37,
    "qualityScore": 5,
    "originalLanguage": "fr",
    "originalText": {
      "fr": "Super vite, efficace et facile"
    },
    "translatedText": {
      "en": "Super fast, efficient and easy"
    }
  },
  {
    "id": "fb-038",
    "displayName": "Marie-Claude B.",
    "facebookUrl": "https://www.facebook.com/marieclaude.blanchet/posts/pfbid02jytpirHkjXbgbjaevYefoTXpCcbzDEuDnsDPTqBB3HeNHTtybajmGG71eGWiRDkUl",
    "postedAt": null,
    "sortOrder": 38,
    "qualityScore": 6.5,
    "originalLanguage": "fr",
    "originalText": {
      "fr": "Rapide et efficace, merci"
    },
    "translatedText": {
      "en": "Fast and efficient, thank you"
    }
  },
  {
    "id": "fb-039",
    "displayName": "Louis H.",
    "facebookUrl": "https://www.facebook.com/louis.hebert.942432/posts/pfbid02tgzSCBwQSUsAjYeRZJ1RsjxM6jz3ebyXadmZC3bkYB6ifVgPF1WZ8EarSfFhVjGTl",
    "postedAt": null,
    "sortOrder": 39,
    "qualityScore": 6,
    "originalLanguage": "fr",
    "originalText": {
      "fr": "J'ai épargné quelques centaines de dollars de frais si je compare avec mon ancien préparateur de déclaration de revenus."
    },
    "translatedText": {
      "en": "I saved a few hundred dollars in fees compared with my previous tax preparer."
    }
  },
  {
    "id": "fb-040",
    "displayName": "Celine D.",
    "facebookUrl": "https://www.facebook.com/celine.dumberry/posts/pfbid0CNFtuHBvqhd6jEdTaEaSrU6nBnfdNwRjU6tGEpwznwTEkvHxzGyojMWxijoihdF4l",
    "postedAt": null,
    "sortOrder": 40,
    "qualityScore": 7.5,
    "originalLanguage": "fr",
    "originalText": {
      "fr": "facile et rapide. fini les casse-têtes avec les impôts et c'est à un prix abordable."
    },
    "translatedText": {
      "en": "Easy and fast. Done with the tax headaches, and it's affordable."
    }
  },
  {
    "id": "fb-041",
    "displayName": "Amélie K.",
    "facebookUrl": "https://www.facebook.com/amanda.boulet.10/posts/pfbid02GAeDw3Lxrcdj8LKkrLz9XXAnA1Ce92gfWWwix7hSBmpCsLGj9e4W6QaFVs2vfj5Hl",
    "postedAt": null,
    "sortOrder": 41,
    "qualityScore": 7.5,
    "originalLanguage": "fr",
    "originalText": {
      "fr": "Rapide, efficace et bon rapport qualité prix"
    },
    "translatedText": {
      "en": "Fast, efficient and great value"
    }
  },
  {
    "id": "fb-042",
    "displayName": "Richard D.",
    "facebookUrl": "https://www.facebook.com/richard.deschenes.73/posts/pfbid02fHk2moVPEXXTktaMZ9vZetwYpD9kAYJGZhgYxtfdMnsJDCiwKHdotZihM7L7DPhNl",
    "postedAt": null,
    "sortOrder": 42,
    "qualityScore": 7.5,
    "originalLanguage": "fr",
    "originalText": {
      "fr": "Service rapide et très professionnel.\nStructure simple et facile de s’y retrouver dans le portail en ligne ."
    },
    "translatedText": {
      "en": "Fast and very professional service.\nSimple structure and easy to find your way around the online portal."
    }
  },
  {
    "id": "fb-043",
    "displayName": "Franc H.",
    "facebookUrl": "https://www.facebook.com/franc.heb.2025/posts/pfbid02bQmam56YxLSoWdxrGHAffHCiqNRoHMtNfjoXcoZQyQLiwSW4Kmi1MoN5pvP7kFivl",
    "postedAt": null,
    "sortOrder": 43,
    "qualityScore": 7.5,
    "originalLanguage": "fr",
    "originalText": {
      "fr": "Deuxième année que je fais affaire avec eux, service rapide et très efficace!"
    },
    "translatedText": {
      "en": "Second year I've been dealing with them — fast and very efficient service!"
    }
  },
  {
    "id": "fb-044",
    "displayName": "Hl C.",
    "facebookUrl": "https://www.facebook.com/hl.chantal/posts/pfbid02tcd4t5kRJrXEV2Y2ChNA4K7f1JwNdKZKNqMvwjQtRREzS1bFMyjtfoXedZc6WJgTl",
    "postedAt": null,
    "sortOrder": 44,
    "qualityScore": 6.5,
    "originalLanguage": "fr",
    "originalText": {
      "fr": "Excellent service, rapide et efficace!"
    },
    "translatedText": {
      "en": "Excellent service, fast and efficient!"
    }
  },
  {
    "id": "fb-045",
    "displayName": "Brigitte L.",
    "facebookUrl": "https://www.facebook.com/brigitte.lachance.56/posts/pfbid02LCa3u9zDRaTMwifhbMyed6KzBYUNcbqHih6oXST3N3XMxsW7te6R6qvsBVdX2LVul",
    "postedAt": null,
    "sortOrder": 45,
    "qualityScore": 7.5,
    "originalLanguage": "fr",
    "originalText": {
      "fr": "J'ai utilisé pour la première fois Accès impôt cette année. Je voulais une contre-vérification des mes déclarations d'impôts. Ils ont fait un travail minutieux, en un temps record."
    },
    "translatedText": {
      "en": "I used Accès Impôt for the first time this year. I wanted a counter-check of my tax returns. They did careful work, in record time."
    }
  },
  {
    "id": "fb-046",
    "displayName": "Donald D.",
    "facebookUrl": "https://www.facebook.com/donald.daigle.5/posts/pfbid0C6CmdVF4NNmmo2MedMSh8nmbCMyoeJpXHhZgKuCmbQxjiPYV7YsHJNZ3LTQADe8Kl",
    "postedAt": null,
    "sortOrder": 46,
    "qualityScore": 7.5,
    "originalLanguage": "fr",
    "originalText": {
      "fr": "C’est ma deuxième année et je trouve votre service remarquable. Continuez votre bon travail, votre entreprise est une réussite"
    },
    "translatedText": {
      "en": "It's my second year and I find your service remarkable. Keep up the good work — your company is a success"
    }
  },
  {
    "id": "fb-047",
    "displayName": "Fay P.",
    "facebookUrl": "https://www.facebook.com/fay.picard1/posts/pfbid0dN8Z1u3ssbucbm9DeDdS5WEnQFUgT3NSrPVUnL4SrYPv89WijtqhLXMoRb9i1T2il",
    "postedAt": null,
    "sortOrder": 47,
    "qualityScore": 9,
    "originalLanguage": "fr",
    "originalText": {
      "fr": "Déjà la deuxième année que j’utilise Accès Impôt. Je suis satisfaite du service, c’est rapide, facile et abordable. Je recommande."
    },
    "translatedText": {
      "en": "Already the second year I've been using Accès Impôt. I'm satisfied with the service — it's fast, easy and affordable. I recommend it."
    }
  },
  {
    "id": "fb-048",
    "displayName": "Maxime B.",
    "facebookUrl": "https://www.facebook.com/maxime.boisvert.104/posts/pfbid02yHTrEhVVfWF7VrpzqAvN71duUsChdz4WGfMtzX8qjz9XLPZeNvJotcqc8P5euqDAl",
    "postedAt": null,
    "sortOrder": 48,
    "qualityScore": 6,
    "originalLanguage": "fr",
    "originalText": {
      "fr": "Fais 2 ans je fais affaire avec eux très satisfait"
    },
    "translatedText": {
      "en": "Been dealing with them for 2 years — very satisfied"
    }
  },
  {
    "id": "fb-049",
    "displayName": "Émilie L.",
    "facebookUrl": "https://www.facebook.com/emilie.lefebvre.96995/posts/pfbid09rF66K7FcJ3qnq7AZWA8PpYyyNYSfzgVDV9UiQgeiL1bmdamr5CPveFoQ7SdxZ5Wl",
    "postedAt": null,
    "sortOrder": 49,
    "qualityScore": 7.5,
    "originalLanguage": "fr",
    "originalText": {
      "fr": "Si j’avais à résumer en 3 mots mon expérience des 3 dernières années; simple, rapide et efficace ! Merci !"
    },
    "translatedText": {
      "en": "If I had to sum up my experience over the last 3 years in 3 words: simple, fast and efficient! Thank you!"
    }
  },
  {
    "id": "fb-050",
    "displayName": "Sylvie T.",
    "facebookUrl": "https://www.facebook.com/sylvie.thibault.504185/posts/pfbid02kVP45a4uPiQaMav1PpZ6tTjidfh83yjyo1tGR3p7qVui9s21eFtRMEaWFdhVf2HLl",
    "postedAt": null,
    "sortOrder": 50,
    "qualityScore": 6.5,
    "originalLanguage": "fr",
    "originalText": {
      "fr": "Excellent service ! Rapide et efficace"
    },
    "translatedText": {
      "en": "Excellent service! Fast and efficient"
    }
  },
  {
    "id": "fb-051",
    "displayName": "Michel P.",
    "facebookUrl": "https://www.facebook.com/michel.poulin.5648/posts/pfbid0ofjDitxdusbsUKc7gqq7y5FamwcS9TBmWCr8kEwPfp1d74GbkhQGXbXiSxQwGYHwl",
    "postedAt": null,
    "sortOrder": 51,
    "qualityScore": 7.5,
    "originalLanguage": "fr",
    "originalText": {
      "fr": "Service rapide et. plate forme pas compliqué"
    },
    "translatedText": {
      "en": "Fast service and a platform that isn’t complicated"
    }
  },
  {
    "id": "fb-052",
    "displayName": "Mélanie T.",
    "facebookUrl": "https://www.facebook.com/melanie.talbot.96/posts/pfbid0eYc4bjdU84VGGKvp3TGLXFywphCjq5KGbJ79NWSRGpPyzreCAMPzBxEHeK2GD44Cl",
    "postedAt": null,
    "sortOrder": 52,
    "qualityScore": 7.5,
    "originalLanguage": "fr",
    "originalText": {
      "fr": "Rapide et précis. Le prix en vaut la peine!"
    },
    "translatedText": {
      "en": "Fast and accurate. Worth the price!"
    }
  },
  {
    "id": "fb-053",
    "displayName": "Andréanne H.",
    "facebookUrl": "https://www.facebook.com/andreanne.houle.94/posts/pfbid02WLzeT8VuUpU4dYDUHZh3oydVTfaVvEdVTH1a552fUSLzDfApnH95pENYcHmNfYvGl",
    "postedAt": null,
    "sortOrder": 53,
    "qualityScore": 6.5,
    "originalLanguage": "fr",
    "originalText": {
      "fr": "Service rapide, simple et efficace!"
    },
    "translatedText": {
      "en": "Fast, simple and efficient service!"
    }
  },
  {
    "id": "fb-054",
    "displayName": "Jean-Sébastien C.",
    "facebookUrl": "https://www.facebook.com/jsdlc73/posts/pfbid05e3phut5wDgrVpCDH5uAVFR4VyzjPSV8YJyPSAnw6tk43g4k7ZfCd5Rqf2MrKH43l",
    "postedAt": null,
    "sortOrder": 54,
    "qualityScore": 7.5,
    "originalLanguage": "fr",
    "originalText": {
      "fr": "Excellent service. Efficace et rapide. Merci !"
    },
    "translatedText": {
      "en": "Excellent service. Efficient and fast. Thank you!"
    }
  },
  {
    "id": "fb-055",
    "displayName": "NJ N.",
    "facebookUrl": "https://www.facebook.com/monique.tremblay.752/posts/pfbid02DfB6363AGZyUTML8mRNRJBLy4sUpzoBLiwi5m1kHXfh96g6R2WqpNez2cTsFpx9Ql",
    "postedAt": null,
    "sortOrder": 55,
    "qualityScore": 6,
    "originalLanguage": "fr",
    "originalText": {
      "fr": "Facilité d’utilisation et efficacité du site et service impeccable."
    },
    "translatedText": {
      "en": "Easy to use and efficient site, and impeccable service."
    }
  },
  {
    "id": "fb-056",
    "displayName": "Danielle B.",
    "facebookUrl": "https://www.facebook.com/danielle.bissonnette/posts/pfbid0N9Adc6NvAV1w856rbzDdMYv9nKKiTNxdX9fX6cF5Vwfw5JpX97LRQ7nfjtBY1Vrzl",
    "postedAt": null,
    "sortOrder": 56,
    "qualityScore": 6,
    "originalLanguage": "fr",
    "originalText": {
      "fr": "Très bon service impeccable, ma deuxième année et je suis très satisfaite, à l'an prochain."
    },
    "translatedText": {
      "en": "Very good, impeccable service — my second year and I'm very satisfied. See you next year."
    }
  },
  {
    "id": "fb-057",
    "displayName": "Robert C.",
    "facebookUrl": "https://www.facebook.com/permalink.php?story_fbid=pfbid0Um9eyufc9pWAwKYL2QjRHtj7PxPF4sE48SQfdSdod9m75e5GxnibUbMykZ5fGALPl&id=61557327470937",
    "postedAt": null,
    "sortOrder": 57,
    "qualityScore": 7.5,
    "originalLanguage": "fr",
    "originalText": {
      "fr": "Avec eux depuis leur début je n’ai rien à redire. Service exceptionnel. Tarifs avantageux. Donc, je serai de retour pour 2027."
    },
    "translatedText": {
      "en": "Been with them since the beginning and I have nothing negative to say. Exceptional service. Advantageous rates. So I'll be back for 2027."
    }
  },
  {
    "id": "fb-058",
    "displayName": "Andrée-Anne H.",
    "facebookUrl": "https://www.facebook.com/andreeanne.hebert.58/posts/pfbid0ELP6VqFK9LFyzjhLjBFe5jNjkQxJRNo16HGpVdjCfD5nPZ2rdjebF7K483gRS4Ltl",
    "postedAt": null,
    "sortOrder": 58,
    "qualityScore": 7.5,
    "originalLanguage": "fr",
    "originalText": {
      "fr": "Rapide, professionnel, efficace, le service d’Accès Impôts nous facilite vraiment la vie chaque année!"
    },
    "translatedText": {
      "en": "Fast, professional, efficient — Accès Impôt’s service really makes our lives easier every year!"
    }
  },
  {
    "id": "fb-059",
    "displayName": "Miimi T.",
    "facebookUrl": "https://www.facebook.com/marieeve.tardif.5/posts/pfbid0kkzuHmtqagygrqPsVJ8eqhV7UCRcrtbkdL8UadcEYSbSm62qzDrUavfa1XsrvcL4l",
    "postedAt": null,
    "sortOrder": 59,
    "qualityScore": 9,
    "originalLanguage": "fr",
    "originalText": {
      "fr": "Service rapide et efficace, répondent rapidement en cas de question. Je l’utilise depuis 2 ans et je suissatisfaite! Je recommande 100%"
    },
    "translatedText": {
      "en": "Fast and efficient service, they reply quickly when you have a question. I've used it for 2 years and I'm satisfied! I recommend 100%"
    }
  },
  {
    "id": "fb-060",
    "displayName": "Geneviève M.",
    "facebookUrl": "https://www.facebook.com/genevieve.montpetit/posts/pfbid02nUVHZBZMthFPiyPWR8jN987nJJBvfuiJQN7rWWxrmZAmKuFbjcHWPPHWKcUw157El",
    "postedAt": null,
    "sortOrder": 60,
    "qualityScore": 9,
    "originalLanguage": "fr",
    "originalText": {
      "fr": "Excellent service! Très rapide et efficace, nous n’avons jamais eu d’erreur dans nos déclarations depuis plusieurs années."
    },
    "translatedText": {
      "en": "Excellent service! Very fast and efficient — we've never had an error in our returns for several years."
    }
  },
  {
    "id": "fb-061",
    "displayName": "Jean-Guy C.",
    "facebookUrl": "https://www.facebook.com/proute51/posts/pfbid02Bx7yqGVaEjfJpcio5CnR35wE955bxxCyqdfEyeJnT3YetEWfGAhxKSHGUMTDKNdcl",
    "postedAt": null,
    "sortOrder": 61,
    "qualityScore": 6,
    "originalLanguage": "fr",
    "originalText": {
      "fr": "Très bon service facile à comprendre organisé vraiment une place que je recommande à tout le monde pour faire vos impôt"
    },
    "translatedText": {
      "en": "Very good service, easy to understand and organized — a place I truly recommend to everyone for doing your taxes"
    }
  },
  {
    "id": "fb-062",
    "displayName": "Gilles F.",
    "facebookUrl": "https://www.facebook.com/gifa0980/posts/pfbid02XaXWkeDBiy6QtTxfuiD1qzzg9vwR1aK6pwGb8jxTfjkX7QcJ1BbRFgWHWUnjxHWpl",
    "postedAt": null,
    "sortOrder": 62,
    "qualityScore": 9,
    "originalLanguage": "fr",
    "originalText": {
      "fr": "Ma deuxième année avec Accès Impôt, ils se démarquent par leur efficacité et rapidité d’envoyer le rapport d’impôts. Excellent prix aussi, je recommande à 100%."
    },
    "translatedText": {
      "en": "My second year with Accès Impôt — they stand out for how efficiently and quickly they send the tax report. Excellent price too, I recommend 100%."
    }
  },
  {
    "id": "fb-063",
    "displayName": "Hélène D.",
    "facebookUrl": "https://www.facebook.com/helene.duchesne.715503/posts/pfbid0222FpJbmxwfCF5YEw4m8k96Uyqi3Jmq6diDxhFpt86vtbTrVyRpYM5HpJmrTxHEQkl",
    "postedAt": null,
    "sortOrder": 63,
    "qualityScore": 9,
    "originalLanguage": "fr",
    "originalText": {
      "fr": "Service efficace et professionnel.\nÇa fait quelques années déjà que nous utilisons Accès Impôt et la famille est très satisfaite !"
    },
    "translatedText": {
      "en": "Efficient and professional service.\nWe've been using Accès Impôt for a few years already and the family is very satisfied!"
    }
  },
  {
    "id": "fb-064",
    "displayName": "Lorenz D.",
    "facebookUrl": "https://www.facebook.com/lorenz.dubuc/posts/pfbid02scXHEGEKR35thdCQsgkribLTT7cNTecdnhnRrVp2581p5CHjrMAFhUEcRYN6DbVYl",
    "postedAt": null,
    "sortOrder": 64,
    "qualityScore": 9,
    "originalLanguage": "fr",
    "originalText": {
      "fr": "Accès Impôt propose un service en ligne rapide, efficace et entièrement à distance. Une plateforme simple, fiable et très professionnelle que je recommande fortement."
    },
    "translatedText": {
      "en": "Accès Impôt offers a fast, efficient, fully remote online service. A simple, reliable and very professional platform that I strongly recommend."
    }
  },
  {
    "id": "fb-065",
    "displayName": "Diane G.",
    "facebookUrl": "https://www.facebook.com/diane.gagne.716/posts/pfbid027TywzWiQrzrQkHNkpCxNzEsyoh3GxDt3XbR9gQfLuV4JRKbJ4GTJWACBC6wVUovjl",
    "postedAt": null,
    "sortOrder": 65,
    "qualityScore": 7.5,
    "originalLanguage": "fr",
    "originalText": {
      "fr": "Je recommande fortement Accès Impôt, c’est maintenant la deuxième année que je fais affaire avec eux, et je suis toujours aussi surprise de la rapidité du service, et de l’exactitude des données, j’étais sceptique au début, mais ils sont présents, répondent à nos questions, et tout ce passe en ligne, c’est merveilleux, j’adore et j’ai adopté"
    },
    "translatedText": {
      "en": "I strongly recommend Accès Impôt — this is now the second year I've dealt with them, and I'm still surprised by how fast the service is and how accurate the data is. I was skeptical at first, but they're present, answer our questions, and everything happens online. It's wonderful — I love it and I've adopted it"
    }
  },
  {
    "id": "fb-066",
    "displayName": "Maryse B.",
    "facebookUrl": "https://www.facebook.com/maryse.bourque.7/posts/pfbid0SauLTdC8xT4rgwcYt8cB2pchYL2vTUmQTbrCA78ptmK3arS7ck8Vov2nwP59aL1rl",
    "postedAt": null,
    "sortOrder": 66,
    "qualityScore": 7.5,
    "originalLanguage": "fr",
    "originalText": {
      "fr": "Excellent service et rapidité d’exécution!\nEt quand on a des questions, on a les réponses exactes!!! \nJe recommande vivement de faire affaire avec Accès Impôts."
    },
    "translatedText": {
      "en": "Excellent service and fast turnaround!\nAnd when you have questions, you get exact answers!!!\nI strongly recommend dealing with Accès Impôt."
    }
  },
  {
    "id": "fb-067",
    "displayName": "Véro G.",
    "facebookUrl": "https://www.facebook.com/veroniik.geniier/posts/pfbid0f3sdC3u4va9a9AoNHHDbqih3DnnLuGMnrtqmLdHMGMitngYmRcVFRU3xnDfqhisWl",
    "postedAt": null,
    "sortOrder": 67,
    "qualityScore": 7.5,
    "originalLanguage": "fr",
    "originalText": {
      "fr": "Excellent service rapide et efficace. Je recommande à 100%"
    },
    "translatedText": {
      "en": "Excellent fast and efficient service. I recommend 100%"
    }
  },
  {
    "id": "fb-068",
    "displayName": "Marie-Pier R.",
    "facebookUrl": "https://www.facebook.com/marie.pier.ruel.700002/posts/pfbid02nkYQpyWEMymuhdbXBBGnvVsBcoD5srLd8TySpMzqtYNmXEXdAYpaiQTtKSx9C31Vl",
    "postedAt": null,
    "sortOrder": 68,
    "qualityScore": 6.5,
    "originalLanguage": "fr",
    "originalText": {
      "fr": "Service rapide et professionnel."
    },
    "translatedText": {
      "en": "Fast and professional service."
    }
  }
]
